import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule, SharedLegModule } from '@approot/shared';
import { DirectRfqComponent } from './direct-rfq.component';
@NgModule({
  declarations: [DirectRfqComponent],
  imports: [SharedModule, SharedLegModule, FormsModule, ReactiveFormsModule],
  exports: [DirectRfqComponent]
})
export class DirectRfqModule {}
